import React__default from 'react';
import InfoOutlined from '../../../../../../node_modules/@mui/icons-material/esm/InfoOutlined.mjs';
import styled from '../../../../../../node_modules/@mui/material/styles/styled.mjs';

const Container$1 = styled('div')({
    width: 'fit-content'
});
const InfoIconCore = ({ tooltipText, color, TooltipComponent: Tooltip })=>{
    return /*#__PURE__*/ React__default.createElement(Container$1, null, /*#__PURE__*/ React__default.createElement(Tooltip, {
        text: tooltipText
    }, /*#__PURE__*/ React__default.createElement(InfoOutlined, {
        htmlColor: color ?? 'inherit',
        fontSize: "inherit"
    })));
};

export { InfoIconCore };
//# sourceMappingURL=InfoIcon.mjs.map
